import {
  makeDeleteApiCall,
  makeGetApiCall,
  makeGetBlobApiCall,
  makePatchApiCall,
  makePostApiCall,
} from "../shared/makeApiCall";
import {
  ShippingReportImageType,
  ShippingReportUpdate,
} from "../types/shippingReports";

export const shippingReportsApi: Record<
  string,
  (...args: any[]) => Promise<any>
> = {
  createForShipping: (shippingId: number | string) =>
    makePostApiCall(`shippings/${shippingId}/report`),

  createForSunOrder: (sunOrderId: number | string) =>
    makePostApiCall(`sun-orders/${sunOrderId}/report`),

  get: (reportId: number | string) =>
    makeGetApiCall(`shipping-reports/${reportId}`),

  update: (reportId: number | string, values: ShippingReportUpdate) =>
    makePatchApiCall(`shipping-reports/${reportId}`, values),

  complete: (reportId: number | string) =>
    makePostApiCall(`shipping-reports/${reportId}/complete`),

  reopen: (reportId: number | string) =>
    makePostApiCall(`shipping-reports/${reportId}/reopen`),

  uploadImages: (
    reportId: number | string,
    type: ShippingReportImageType,
    files: File[],
  ) => {
    const formData = new FormData();
    formData.append("type", type);
    files.forEach((file) => formData.append("images[]", file));

    return makePostApiCall(`shipping-reports/${reportId}/images`, formData);
  },

  updateImage: (
    imageId: number,
    values: { caption?: string | null; type?: ShippingReportImageType },
  ) => makePatchApiCall(`shipping-report-images/${imageId}`, values),

  deleteImage: (imageId: number) =>
    makeDeleteApiCall(`shipping-report-images/${imageId}`),

  reorderImages: (reportId: number | string, imageIds: number[]) =>
    makePostApiCall(`shipping-reports/${reportId}/images/reorder`, {
      image_ids: imageIds,
    }),

  downloadPdf: (reportId: number | string) =>
    makeGetBlobApiCall(`shipping-reports/${reportId}/pdf`),

  createArrivalTemperature: (
    reportId: number | string,
    values: {
      temperatureCelsius: string;
      image: File;
      note?: string;
    },
  ) => {
    const formData = new FormData();
    formData.append("temperature_celsius", values.temperatureCelsius);
    formData.append("image", values.image);
    if (values.note) formData.append("note", values.note);

    return makePostApiCall(
      `shipping-reports/${reportId}/arrival-temperatures`,
      formData,
    );
  },

  deleteArrivalTemperature: (readingId: number) =>
    makeDeleteApiCall(`shipping-report-arrival-temperatures/${readingId}`),
};
